export default "__VITE_ASSET__5ueHAtn9JtiQ3lCiqsnAfg__"